// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__+GCid","cursor":"Hero_cursor__qhT8V","blink":"Hero_blink__Hg2eB","ctaButton":"Hero_ctaButton__yayb9"};